import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ArrowSvg from "../../../../assets/images/arrow-back.svg";
import Layout from "../../../components/Provider/Layout";
import QrScan from "../../../components/Provider/QrScan";
import CustomPaper from "../../../components/shared/CustomPaper";
import ListItem from "../../../components/shared/ListItem";
import Loading from "../../../components/shared/Loading";
import MessageModal from "../../../components/shared/MessageModal";
import ScanButton from "../../../components/shared/ScanButton";
import Search from "../../../components/shared/Search";
import useLocalStorage from "../../../hooks/useLocalStorage";
import ProviderServices from "../../../services/ProviderServices";
import { validateNumber } from "../../../utils/regexValidator";
// import dummyData from './data'
import "./Reubication.scss";

function Reubication() {
  const [textSearch, setTextSearch] = useState("");
  const [reubicationData, setReubicationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ubicationError, setUbicationError] = useState(false);
  const [modalNoInternet, setModalNoInternet] = useState(false);
  const history = useHistory();
  const [userappret] = useLocalStorage("userappret");
  const [scanning, setScanning] = useState(false);
  const [modalErrorCud, setModalErrorCud] = useState(false);
  const [modalSuccessCud, setModalSuccessCud] = useState(false);
  const [selectedCud, setSelectedCud] = useState({});
  const [selectedCarton, setSelectedCarton] = useState(null);
  const [modalInternetError, setModalInternetError] = useState(false);

  useEffect(() => {
    let timer = "";
    if (!userappret.pickupPointId) {
      setUbicationError(true);
      timer = setTimeout(() => {
        history.push("/home");
      }, 2500);
    }
    return () => (timer ? clearTimeout(timer) : null);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const cuds = await ProviderServices.getUbicationCuds(
          userappret.pickupPointId
        );
        setReubicationData(formatCuds(cuds));
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
        setModalNoInternet(true);
        setTimeout(() => {
          setModalNoInternet(false);
        }, 3000);
      }
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  const formatCuds = (cuds) => {
    return cuds.reduce((filtered, cud) => {
      if (cud.placeId) {
        const formattedCud = {
          cud: cud.cudNumber,
          quantity: cud.quantity,
          place: cud.placeName,
          guideNumber: cud.guideNumber,
          date: moment(cud.updatedAt).format("DD-MM-YY hh:mm"),
          placeId: cud.placeId,
          originType: cud.originType,
          skus: cud.skus,
          suborder: cud.suborder,
        };
        filtered.push(formattedCud);
      }
      return filtered;
    }, []);
  };

  const handleTextChange = (e) => {
    const value = e.target.value;
    if (validateNumber(value) && value.length < 23) setTextSearch(value);
  };

  const renderItems = () => {
    const getCudsRipley = reubicationData.filter((data) =>
      data.originType.includes("ripley")
    );
    const getCudsMarketplace = reubicationData.filter((data) =>
      data.originType.includes("mkp")
    );
    return (
      <>
        <ListItem
          img={"./IconListRipley.png"}
          desc={"Productos Ripley"}
          cant={getCudsRipley.length}
        >
          {getCudsRipley.map((d, i) =>
            d.cud.includes(textSearch) ||
            d.guideNumber.toString().includes(textSearch) ? (
              <CustomPaper
                key={`tile-${d.cud}-${i}`}
                title={`Guía: ${d.guideNumber}`}
                description={`CUD: ${d.cud}`}
                quantity={<div>x {d.quantity}</div>}
                enable={true}
                onClick={() =>
                  history.push(`reubicacion/${d.cud}`, {
                    cudToProcess: {
                      id: d.cud,
                      numProducts: d.quantity,
                      guide: d.guideNumber,
                      placeId: d.placeId,
                      type: d.originType,
                    },
                  })
                }
              />
            ) : null
          )}
        </ListItem>
        <ListItem
          img={"./IconListMarketplace.png"}
          desc={"Marketplace"}
          cant={getCudsMarketplace.length}
        >
          {getCudsMarketplace.map((cf, i) =>
            cf.guideNumber.includes(textSearch) ||
            cf.suborder.toString().includes(textSearch) ||
            cf.skus.find((sku) => sku.sku.includes(textSearch)) ? (
              <CustomPaper
                key={`tile-${cf.skus.sku}-${i}`}
                title={<div>OC: {cf.suborder}</div>}
                description={cf.skus.map((sku) => {
                  return <div key={sku.sku}>SKU: {sku.sku}</div>;
                })}
                quantity={cf.skus.map((sku) => {
                  return <div key={sku.sku}>x{sku.quantity}</div>;
                })}
                enable={true}
                onClick={() =>
                  history.push(`reubicacion/${cf.suborder}`, {
                    cudToProcess: {
                      id: cf.suborder,
                      numProducts: cf.numProducts,
                      guide: cf.suborder,
                      placeId: cf.placeId,
                      place: cf.place,
                      skus: cf.skus,
                      type: cf.originType,
                    },
                  })
                }
              />
            ) : null
          )}
        </ListItem>
      </>
    );
  };

  const handleScan = async (scanResult) => {
    setScanning(false);
    const carton = scanResult || selectedCarton;
    try {
      setLoading(true);
      const cud = await ProviderServices.getCudByCarton(carton);
      const listedCud = reubicationData.find((c) => c.cud === cud);
      setSelectedCud(listedCud || { cud });
      setLoading(false);
      if (listedCud) {
        setModalSuccessCud(true);
      } else setModalErrorCud(true);
    } catch (e) {
      setLoading(false);
      setSelectedCarton(carton);
      setModalInternetError(true);
    }
  };

  return !scanning ? (
    <Layout>
      <Loading visible={loading} />
      <MessageModal
        visible={modalNoInternet}
        closeModal={() => setModalNoInternet(false)}
        message="No tiene conexión a internet. Conéctese y refresque la pantalla"
        type={2}
      />
      <MessageModal
        visible={ubicationError}
        // closeModal={() => setUbicationError(false)}
        message="No tiene una ubicación asignada, elija una o pida que se le asigne una"
        type={1}
      />
      <MessageModal
        visible={modalInternetError}
        closeModal={() => setModalInternetError(false)}
        type={24}
        title="No hay conexión"
        message="Revisa tu conexión a internet e inténtalo de nuevo"
        txtBtn1="VOLVER"
        onClickBtn1={() => {
          setModalInternetError(false);
        }}
        txtBtn2="REINTENTAR"
        onClickBtn2={() => {
          setModalInternetError(false);
          handleScan();
        }}
      />
      <MessageModal
        visible={modalErrorCud}
        closeModal={() => setModalErrorCud(false)}
        type={12}
        title="CUD no listado"
        txtBtn1="ESCANEAR DE NUEVO"
        onClickBtn1={() => {
          setModalErrorCud(false);
          setScanning(true);
        }}
        txtBtn2="REGRESAR A LA LISTA"
        onClickBtn2={() => {
          setModalErrorCud(false);
          setScanning(false);
        }}
        inlineButtons
      >
        <div className="modal-warning-message">
          <p>
            El código CUD
            <br />
            <span>{selectedCud && selectedCud.cud}</span>
            <br />
            no aparece en la lista
          </p>
        </div>
      </MessageModal>
      <MessageModal
        visible={modalSuccessCud}
        closeModal={() => setModalSuccessCud(false)}
        type={13}
        title="Verificar el código CUD"
        txtBtn2="CONTINUAR"
        onClickBtn2={() => {
          setModalSuccessCud(false);
          history.push(`reubicacion/${selectedCud.cud}`, {
            cudToProcess: {
              id: selectedCud.cud,
              numProducts: selectedCud.quantity,
              guide: selectedCud.guideNumber,
              placeId: selectedCud.placeId,
              type: selectedCud.type,
            },
          });
        }}
        inlineButtons
      >
        <div className="modal-warning-message">
          <p>
            Se ha escaneado el CUD
            <br />
            <span>{selectedCud && selectedCud.cud}</span>
          </p>
        </div>
      </MessageModal>
      <div className="reubication-container">
        <div className="reubication-header">
          <Link
            to={{
              pathname: "/home",
              state: {
                plate: userappret.plate,
                operator: userappret.operator,
                from: "reubicacion",
              },
            }}
            style={{ display: "flex" }}
          >
            <img src={ArrowSvg} alt="atras" />
          </Link>
          <h3>Reubicación de productos</h3>
        </div>
        <div className="reubication-search-container">
          <Search
            text={textSearch}
            setText={handleTextChange}
            placeholder={"GUÍA, CUD, OC o SKU"}
          />
          <ScanButton active={true} onPress={() => setScanning(true)} />
        </div>
        <div className="reubication-items-container">{renderItems()}</div>
        {/* <div className='reubication-scan'>
          <ScanButton
            active={true}
            onPress={() => setScanning(true)}
          />
        </div> */}
      </div>
    </Layout>
  ) : (
    <QrScan
      handleScan={handleScan}
      onClose={() => setScanning(false)}
      barcode
      title="Escaneo de cartón"
      subtitle="Escanea el código de barras ubicado en la etiqueta del cartón."
    />
  );
}

export default Reubication;
